// import { dbName, dbVersion } from "./consts.js";

export const chunksMergeConf = {
    // dbName,
    // dbVersion,
    store: 'chunksMergeCache',
};



//seems dbname and dbversion arent required here